// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__2Etyk","upgrade":"styles_upgrade__2wf-8","animatePage":"styles_animatePage__KZ2kt","fade":"styles_fade__2720i"};